import { set } from "date-fns";
import React, { useState } from "react";

const Accordion = ({
  children,
  header,
  targetID,
  actionButton,
  fixedHeight = null,
  defaultExpanded = true,
  overrideOpenState = null,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleAccordion = () => {
    if (overrideOpenState !== null) {
      setIsExpanded(overrideOpenState);
      return;
    }
    setIsExpanded(!isExpanded);
  };

  const getIsExpanded = () => {
    return overrideOpenState !== null ? overrideOpenState : isExpanded;
  };

  return (
    <div className="accordion-component p-8">
      <div className="box-area">
        <div className="single-box pt-0 d-block pb-0 mb-0">
          <div
            className="title d-flex justify-content-between align-items-center"
            onClick={toggleAccordion}
            role="button"
            tabIndex={0}
            aria-expanded={getIsExpanded()}
            aria-controls={targetID}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggleAccordion();
              }
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex align-items-center gap-8">
              {overrideOpenState === null && (
                <svg
                  className={`rotate-arrow ${
                    getIsExpanded() ? "expanded" : "collapsed rotated"
                  }`}
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5 9.16748L7 5.66748L3.5 9.16748"
                    stroke="#666666"
                    strokeWidth="1.33"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
              <span>{header}</span>
            </div>
            <div className="action-buttons">{actionButton && getIsExpanded() && actionButton}</div>
          </div>
        </div>
      </div>

      <div
        id={targetID}
        role="tabpanel"
        className={`panel-collapse collapse ${getIsExpanded() ? "in" : ""}`}
        aria-hidden={!getIsExpanded()}
        style={{
          display: "grid",
          gridTemplateRows: getIsExpanded() ? "1fr" : "0fr",
          transition: "grid-template-rows 0.3s ease-in-out",
        }}
      >
        <div
          className={`${fixedHeight !== null ? "scrollable scrollable-y" : ""}`}
          style={{
            overflow: fixedHeight !== null ? "auto" : "hidden",
            maxHeight: fixedHeight !== null ? fixedHeight : "auto",
          }}
        >
          <div className="p-12 border-0">
            <div className="form-content">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/common/Accordion.js